module.exports = __webpack_public_path__ + "static/responsible-investment-4e7a2312b6e0f14659beeaa175c99b0d.webm";